/**
 * This is the login data service.
 * @memberOf Login Module
 * @namespace Login Data Service
 */

/**
 * @name LoginDataService
 * @desc Create the data service.
 * @param $q
 * @param $http
 * @param coreService
 * @memberOf Login Module.Login Data Service
 * @ngInject
 */
var loginDataFactory = function ($q, $http, coreService) {
    // Create the service.
    var service = {};
    return service;
}

export default loginDataFactory;



// WEBPACK FOOTER //
// ./src/login/login.data.service.js